import { CMVarAggregationObject, isNumber } from '@iotv/datamodel';
import { existsFilter } from '@iotv/core-services';
const debug = process.env.REACT_APP_DEBUG && false;
export const aggregateGeofenceMetrics = (GeofenceMetrics) => {
    debug && console.log('aggregateGeofenceMetrics', GeofenceMetrics);
    let aggregate;
    if (GeofenceMetrics.length > 0) {
        aggregate = {
            esp: aggregateCMV(GeofenceMetrics.map((metrics) => metrics.esp)),
            power: aggregateCMV(GeofenceMetrics.map((metrics) => metrics.power)),
            rssi: aggregateCMV(GeofenceMetrics.map((metrics) => metrics.rssi)),
            sf: aggregateCMV(GeofenceMetrics.map((metrics) => metrics.sf)),
            snr: aggregateCMV(GeofenceMetrics.map((metrics) => metrics.snr)),
            dropped: GeofenceMetrics.map((metrics) => metrics.dropped)
                .filter(existsFilter)
                .filter((n) => typeof n === 'number')
                .reduce((total, cur) => cur + total, 0),
        };
    }
    return aggregate;
};
const aggregateCMV = (cmvs) => {
    const cmv = cmvs.reduce((aggregated, current) => {
        aggregated.mean = (aggregated.cn * aggregated.mean + current.cn * current.mean) / (aggregated.cn + current.cn);
        /** RSE — based on cursory check on ChatGPT <-- :-( */
        aggregated.sqDiffFromMean = aggregated.sqDiffFromMean + current.sqDiffFromMean;
        aggregated.cn += current.cn;
        aggregated.firstTimestamp = aggregated.firstTimestamp
            ? current.firstTimestamp
                ? Math.min(aggregated.firstTimestamp, current.firstTimestamp)
                : aggregated.firstTimestamp
            : undefined;
        aggregated.lastTimeStamp = aggregated.lastTimeStamp
            ? current.lastTimeStamp
                ? Math.min(aggregated.lastTimeStamp, current.lastTimeStamp)
                : aggregated.lastTimeStamp
            : undefined;
        aggregated.max = isNumber(aggregated.max) ? (current.max ? Math.max(aggregated.max, current.max) : aggregated.max) : undefined;
        aggregated.min = isNumber(aggregated.min) ? (current.min ? Math.min(aggregated.min, current.min) : aggregated.min) : undefined;
        return aggregated;
    }, 
    /**
     * We create a new object for the start, and not mutate it, otherwise it will increment every rerender!
     */
    new CMVarAggregationObject({
        cn: 0,
        firstTimestamp: 0,
        lastTimeStamp: 0,
        mean: 0,
        sqDiffFromMean: 0,
        max: 0,
        min: 0,
    }));
    return cmv;
};
